/**
 * @name: merchantManagement.js
 * @description: 商户管理路由
 * @author: 于海威
 * @create: 2020/08/07 17:15:51
 * @update: 2020/08/07 17:15:51
 */

export default [
  {
    path: '/merchant/company/list',
    name: 'companyManagement',
    component: () => import('@/views/merchant/company/List'),
    meta: {
      title: '推广公司管理'
    }
  },
  {
    path: '/merchant/saleman/list',
    name: 'salemanManagement',
    component: () => import('@/views/merchant/saleman/List'),
    meta: {
      title: '业务员管理'
    }
  },
  {
    path: '/merchant/saleman/demission',
    name: 'demission',
    component: () => import('@/views/merchant/saleman/Demission'),
    meta: {
      title: '业务员离职',
      parentRoutePath: 'salemanManagement'
    }
  },
  {
    path: '/merchant/dealer/list',
    name: 'dealersManagement',
    component: () => import('@/views/merchant/dealer/List'),
    meta: {
      title: '门店管理'
    }
  },
  {
    path: '/merchant/dealer/add',
    name: 'dealerAdd',
    component: () => import('@/views/merchant/dealer/Add'),
    meta: {
      title: '添加门店',
      parentRoutePath: 'dealersManagement'
    }
  },
  {
    path: '/merchant/import/list',
    name: 'shopImport',
    component: () => import('@/views/merchant/import/List'),
    meta: {
      title: '门店批量导入'
    }
  },
  {
    path: '/merchant/shopInShop/list',
    name: 'shopInShopManagement',
    component: () => import('@/views/merchant/shopInShop/List'),
    meta: {
      title: '店中店管理'
    }
  },
  {
    path: '/merchant/shopInShop/detail',
    name: 'shopInShopDetail',
    component: () => import('@/views/merchant/shopInShop/Detail'),
    meta: {
      title: '查看店中店',
      parentRoutePath: 'shopInShopManagement'
    }
  },
  {
    path: '/merchant/shopGrade/list',
    name: 'shopGradeManagement',
    component: () => import('@/views/merchant/shopGrade/List'),
    meta: {
      title: '门店等级管理'
    }
  },
  {
    path: '/merchant/shopGrade/detail',
    name: 'shopGradeDetail',
    component: () => import('@/views/merchant/shopGrade/Detail'),
    meta: {
      title: '查看门店等级详情',
      parentRoutePath: 'shopGradeManagement'
    }
  },
  {
    path: '/merchant/controlCargo/list',
    name: 'controlCargo',
    component: () => import('@/views/merchant/controlCargo/List'),
    meta: {
      title: '控货列表'
    }
  },
  {
    path: '/merchant/controlCargo/add',
    name: 'addControlCargo',
    component: () => import('@/views/merchant/controlCargo/Add'),
    meta: {
      title: '添加控货',
      parentRoutePath: '/merchant/controlCargo/list'
    }
  },
  {
    path: '/merchant/controlCargo/applylist',
    name: 'applyList',
    component: () => import('@/views/merchant/controlCargo/ApplyList'),
    meta: {
      title: '销售申请列表'
    }
  },
  {
    path: '/merchant/controlCargo/applydetail',
    name: 'applyDetail',
    component: () => import('@/views/merchant/controlCargo/ApplyDetail'),
    meta: {
      title: '销售申请详情',
      parentRoutePath: 'applyList'
    }
  },
  {
    path: '/merchant/busiCust/list',
    name: 'custManagement',
    component: () => import('@/views/merchant/busiCust/List'),
    meta: {
      title: '客商列表'
    }
  },
  {
    path: '/merchant/busiCust/add',
    name: 'custAdd',
    component: () => import('@/views/merchant/busiCust/Add'),
    meta: {
      title: '添加客商',
      parentRoutePath: 'custManagement'
    }
  }
];
